// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeftContainer_leftContainer__sHpvX {
  width: 65%;
}
.LeftContainer_headerContainer__VLdbB {
  margin-bottom: 40px;
  row-gap: 24px;
}
.LeftContainer_heading__5C5Pp {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-align: left;
}
.LeftContainer_leftContainer__sHpvX,
.LeftContainer_headerContainer__VLdbB,
.LeftContainer_polaznikCardContainer__Si5Wm,
.LeftContainer_sliderContainer__YhP1S {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.LeftContainer_searchIcon__Z3nB6 {
  height: 24px;
  margin: 10px 16px 0px;
  position: absolute;
  width: 24px;
}

.LeftContainer_searchInput__5rN7X {
  border: 1px solid #d9dce0;
  width: 438px;
  height: 46px;
  padding: 8px 16px 8px 46px;
  border-radius: 8px;
}
.LeftContainer_searchInput__5rN7X::placeholder {
  color: rgba(95, 109, 126, 0.6);
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.LeftContainer_searchInput__5rN7X:focus {
  border: 1px solid rgba(203, 156, 45, 1);
  outline: none;
}
.LeftContainer_polaznikCardContainer__Si5Wm {
  align-items: baseline;
  justify-content: center;
  gap: 32px;
  width: 100%;
}
.LeftContainer_cardsContainer__JyX1q {
  display: flex;
  column-gap: 28px;
  margin-bottom: 64px;
  width: 100%;
}
.LeftContainer_sliderContainer__YhP1S {
  width: 100%;
}
.LeftContainer_sliderHeaderContainer__hNFsw {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
  width: 100%;
}
.LeftContainer_sliderHeading__fpckg {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin: 0px;
  max-width: 24ch;
  overflow: hidden;
  display: "-webkit-box";
  -webkit-line-clamp: 5;
  -webkit-box-orient: "vertical";
  text-overflow: "ellipsis";
  white-space: "normal";
  margin-top: 48px;
}
.LeftContainer_seeMoreContainer__K9OmZ {
  align-items: center;
  column-gap: 17px;
  cursor: pointer;
  display: flex;
}
.LeftContainer_seeMoreContainer__K9OmZ:hover .LeftContainer_seeMoreText__FLcmA {
  color: #cb9c2d;
  transition: color 200ms ease-in-out;
}
.LeftContainer_seeMoreIcon__L7RVL {
  stroke: #9fa7b2;
  transition: stroke 200ms ease-in-out;
}
.LeftContainer_seeMoreContainer__K9OmZ:hover .LeftContainer_seeMoreIcon__L7RVL {
  stroke: #cb9c2d;
  transition: stroke 200ms ease-in-out;
}
.LeftContainer_seeMoreText__FLcmA {
  color: #9fa7b2;
  cursor: pointer;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  margin: 0px;
  letter-spacing: -0.001em;
  transition: color 200ms ease-in-out;
}

.LeftContainer_carouselBlurContainer__93Vtp,
.LeftContainer_carouselContainerLeft__2r63I,
.LeftContainer_carouselContainerRight__sWfpK {
  mask: linear-gradient(
    to left,
    transparent,
    black 10%,
    black 90%,
    transparent
  );
}
.LeftContainer_carouselBlurContainer__93Vtp,
.LeftContainer_carouselContainer__strPL,
.LeftContainer_carouselContainerLeft__2r63I,
.LeftContainer_carouselContainerRight__sWfpK {
  display: flex;
  column-gap: 40px;
  height: 370px;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 20px;
}

.LeftContainer_carouselContainer__strPL:hover {
  overflow-x: auto;
}

.LeftContainer_carouselContainerLeft__2r63I {
  mask: linear-gradient(
    to right,
    transparent,
    black 10%,
    black 100%,
    transparent
  );
}
.LeftContainer_carouselContainerRight__sWfpK {
  mask: linear-gradient(
    to left,
    transparent,
    black 10%,
    black 100%,
    transparent
  );
}

.LeftContainer_carouselContainer__strPL::-webkit-scrollbar,
.LeftContainer_carouselBlurContainer__93Vtp::-webkit-scrollbar,
.LeftContainer_carouselContainerLeft__2r63I::-webkit-scrollbar,
.LeftContainer_carouselContainerRight__sWfpK::-webkit-scrollbar {
  height: 7px !important;
}

.LeftContainer_carouselContainer__strPL::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.LeftContainer_carouselContainer__strPL::-webkit-scrollbar-thumb {
  background: rgb(165, 162, 162);
}

.LeftContainer_carouselContainer__strPL::-webkit-scrollbar-thumb:hover {
  background: rgb(142, 139, 139);
}

@media screen and (max-width: 1300px) {
  .LeftContainer_carouselContainer__strPL {
    min-width: 90%;
  }
}

@media screen and (max-width: 1105px) {
  .LeftContainer_sliderHeaderContainer__hNFsw {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .LeftContainer_sliderHeading__fpckg {
    min-width: 100%;
  }
  .LeftContainer_leftContainer__sHpvX {
    width: 100%;
  }
  .LeftContainer_sliderContainer__YhP1S {
    width: 100%;
  }

  .LeftContainer_carouselContainer__strPL {
    overflow-x: scroll;
    scrollbar-width: auto;
    -ms-overflow-style: auto;
    min-width: 100%;
  }
  .LeftContainer_cardsContainer__JyX1q {
    width: 100%;
    justify-content: center;
  }
}
@media screen and (max-width: 720px) {
  .LeftContainer_cardsContainer__JyX1q {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .LeftContainer_sliderContainer__YhP1S {
    margin-left: 20px;
  }
}

@media screen and (max-width: 450px) {
  .LeftContainer_sliderContainer__YhP1S {
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/dashboard/components/LeftContainer/LeftContainer.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;AAClB;AACA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;;EAGE;;;;;;GAMC;AACH;AACA;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;;;GAMC;AACH;AACA;EACE;;;;;;GAMC;AACH;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;EACjB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".leftContainer {\n  width: 65%;\n}\n.headerContainer {\n  margin-bottom: 40px;\n  row-gap: 24px;\n}\n.heading {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-align: left;\n}\n.leftContainer,\n.headerContainer,\n.polaznikCardContainer,\n.sliderContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.searchIcon {\n  height: 24px;\n  margin: 10px 16px 0px;\n  position: absolute;\n  width: 24px;\n}\n\n.searchInput {\n  border: 1px solid #d9dce0;\n  width: 438px;\n  height: 46px;\n  padding: 8px 16px 8px 46px;\n  border-radius: 8px;\n}\n.searchInput::placeholder {\n  color: rgba(95, 109, 126, 0.6);\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.searchInput:focus {\n  border: 1px solid rgba(203, 156, 45, 1);\n  outline: none;\n}\n.polaznikCardContainer {\n  align-items: baseline;\n  justify-content: center;\n  gap: 32px;\n  width: 100%;\n}\n.cardsContainer {\n  display: flex;\n  column-gap: 28px;\n  margin-bottom: 64px;\n  width: 100%;\n}\n.sliderContainer {\n  width: 100%;\n}\n.sliderHeaderContainer {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  width: 100%;\n}\n.sliderHeading {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  max-width: 24ch;\n  overflow: hidden;\n  display: \"-webkit-box\";\n  -webkit-line-clamp: 5;\n  -webkit-box-orient: \"vertical\";\n  text-overflow: \"ellipsis\";\n  white-space: \"normal\";\n  margin-top: 48px;\n}\n.seeMoreContainer {\n  align-items: center;\n  column-gap: 17px;\n  cursor: pointer;\n  display: flex;\n}\n.seeMoreContainer:hover .seeMoreText {\n  color: #cb9c2d;\n  transition: color 200ms ease-in-out;\n}\n.seeMoreIcon {\n  stroke: #9fa7b2;\n  transition: stroke 200ms ease-in-out;\n}\n.seeMoreContainer:hover .seeMoreIcon {\n  stroke: #cb9c2d;\n  transition: stroke 200ms ease-in-out;\n}\n.seeMoreText {\n  color: #9fa7b2;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  margin: 0px;\n  letter-spacing: -0.001em;\n  transition: color 200ms ease-in-out;\n}\n\n.carouselBlurContainer,\n.carouselContainerLeft,\n.carouselContainerRight {\n  mask: linear-gradient(\n    to left,\n    transparent,\n    black 10%,\n    black 90%,\n    transparent\n  );\n}\n.carouselBlurContainer,\n.carouselContainer,\n.carouselContainerLeft,\n.carouselContainerRight {\n  display: flex;\n  column-gap: 40px;\n  height: 370px;\n  width: 100%;\n  overflow-x: auto;\n  white-space: nowrap;\n  padding-bottom: 20px;\n}\n\n.carouselContainer:hover {\n  overflow-x: auto;\n}\n\n.carouselContainerLeft {\n  mask: linear-gradient(\n    to right,\n    transparent,\n    black 10%,\n    black 100%,\n    transparent\n  );\n}\n.carouselContainerRight {\n  mask: linear-gradient(\n    to left,\n    transparent,\n    black 10%,\n    black 100%,\n    transparent\n  );\n}\n\n.carouselContainer::-webkit-scrollbar,\n.carouselBlurContainer::-webkit-scrollbar,\n.carouselContainerLeft::-webkit-scrollbar,\n.carouselContainerRight::-webkit-scrollbar {\n  height: 7px !important;\n}\n\n.carouselContainer::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.carouselContainer::-webkit-scrollbar-thumb {\n  background: rgb(165, 162, 162);\n}\n\n.carouselContainer::-webkit-scrollbar-thumb:hover {\n  background: rgb(142, 139, 139);\n}\n\n@media screen and (max-width: 1300px) {\n  .carouselContainer {\n    min-width: 90%;\n  }\n}\n\n@media screen and (max-width: 1105px) {\n  .sliderHeaderContainer {\n    width: 100%;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .sliderHeading {\n    min-width: 100%;\n  }\n  .leftContainer {\n    width: 100%;\n  }\n  .sliderContainer {\n    width: 100%;\n  }\n\n  .carouselContainer {\n    overflow-x: scroll;\n    scrollbar-width: auto;\n    -ms-overflow-style: auto;\n    min-width: 100%;\n  }\n  .cardsContainer {\n    width: 100%;\n    justify-content: center;\n  }\n}\n@media screen and (max-width: 720px) {\n  .cardsContainer {\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n  }\n  .sliderContainer {\n    margin-left: 20px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .sliderContainer {\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftContainer": `LeftContainer_leftContainer__sHpvX`,
	"headerContainer": `LeftContainer_headerContainer__VLdbB`,
	"heading": `LeftContainer_heading__5C5Pp`,
	"polaznikCardContainer": `LeftContainer_polaznikCardContainer__Si5Wm`,
	"sliderContainer": `LeftContainer_sliderContainer__YhP1S`,
	"searchIcon": `LeftContainer_searchIcon__Z3nB6`,
	"searchInput": `LeftContainer_searchInput__5rN7X`,
	"cardsContainer": `LeftContainer_cardsContainer__JyX1q`,
	"sliderHeaderContainer": `LeftContainer_sliderHeaderContainer__hNFsw`,
	"sliderHeading": `LeftContainer_sliderHeading__fpckg`,
	"seeMoreContainer": `LeftContainer_seeMoreContainer__K9OmZ`,
	"seeMoreText": `LeftContainer_seeMoreText__FLcmA`,
	"seeMoreIcon": `LeftContainer_seeMoreIcon__L7RVL`,
	"carouselBlurContainer": `LeftContainer_carouselBlurContainer__93Vtp`,
	"carouselContainerLeft": `LeftContainer_carouselContainerLeft__2r63I`,
	"carouselContainerRight": `LeftContainer_carouselContainerRight__sWfpK`,
	"carouselContainer": `LeftContainer_carouselContainer__strPL`
};
export default ___CSS_LOADER_EXPORT___;
